(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/models/tips-info.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/models/tips-info.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.models = svs.matchen.models || {};

  svs.matchen.models.TipsInfo = Backbone.Model.extend({
    defaults: function() {
      return JSON.parse(JSON.stringify({
        goalAvgTrend: {
          active: true
        },
        svenskaFolket: {
          active: true
        },
        displayActionBar: false
      }));
    },

    initialize: function() {
      var storageTipsInfo = svs.components.Storage.browser.get(
        svs.matchen.TIPSINFO,
        svs.matchen.STORAGE_NAME
      );

      if (storageTipsInfo) {
        this.set(storageTipsInfo);
      }

      this.preserve = true;
      this.preserveBindings = true;

      this.listenTo(this, 'change', this.saveToLocalStorage);
    },

    setGoalAvgTrend: function(active) {
      this.set('goalAvgTrend', { active: active });
    },

    setSvenskaFolket: function(active) {
      this.set('svenskaFolket', { active: active });
    },

    isGoalAvgTrendActive: function() {
      return this.get('goalAvgTrend').active;
    },

    isSvenskaFolketActive: function() {
      return this.get('svenskaFolket').active;
    },

    getNumberOfActives: function() {
      return _.where(this.attributes, { active: true }).length;
    },

    isAnyActive: function() {
      return this.getNumberOfActives() > 0 && this.get('displayActionBar');
    },

    displayActionBar: function(displayActionBar) {
      this.set({ displayActionBar: displayActionBar }, { silent: true });

      if (displayActionBar) {
        this.trigger('change', this);
      }
    },

    reset: function() {
      this.set(_.result(this, 'defaults'));
    },

    disableTipsInfo: function() {
      this.set({
        svenskaFolket: { active: false },
        goalAvgTrend: { active: false }
      });
    },

    saveToLocalStorage: function() {
      svs.components.Storage.browser.set(
        svs.matchen.TIPSINFO,
        svs.matchen.STORAGE_NAME,
        this.toJSON(),
        svs.components.Storage.constants.EXPIRES_1H
      );
    }
  });
})(Backbone, _, svs);


 })(window);